export default __webpack_public_path__ + "static/media/dg3.fad96f73.jpg";